import { toastController } from '@ionic/core';

let lastWarningTime = 0;
const WARNING_THROTTLE = 30000;

async function showLowMemoryToast() {
  const now = Date.now();
  if (now - lastWarningTime < WARNING_THROTTLE) return;

  lastWarningTime = now;

  const toast = await toastController.create({
    message: 'Low memory detected. Please close unused tabs.',
    duration: 4000,
    position: 'bottom',
    color: 'warning',
  });

  await toast.present();
  console.warn('⚠️ Low memory toast shown (web)');
}

export function initWebLowMemoryListener() {
  console.log('🔧 Initializing web low-memory listener');

  window.addEventListener('lowmemory', showLowMemoryToast);

  console.log('✅ Web low-memory listener ready');
}
